module.exports = __webpack_public_path__ + "static/media/news.514fcf23.svg";